import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { CHART_ACCENT, CHART_GRID, axisTickStyle, tooltipContentStyle, tooltipLabelStyle } from './chartTheme';

const SOURCE_LABELS = {
  tiktok: 'TikTok',
  instagram: 'Instagram',
  telegram: 'Telegram',
  discord: 'Discord',
  friends: 'Friends',
  other: 'Other',
};

const SurveySourceChart = ({ data }) => {
  const chartData = Object.entries(data || {})
    .map(([source, count]) => ({ label: SOURCE_LABELS[source] || source, count }))
    .sort((a, b) => b.count - a.count);

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={chartData} layout="vertical" margin={{ top: 8, right: 32, left: 0, bottom: 0 }} barCategoryGap="20%">
        <CartesianGrid stroke={CHART_GRID} strokeDasharray="0" horizontal={false} />
        <XAxis type="number" allowDecimals={false} tick={axisTickStyle} axisLine={{ stroke: CHART_GRID }} tickLine={false} />
        <YAxis type="category" dataKey="label" tick={axisTickStyle} axisLine={false} tickLine={false} width={80} />
        <Tooltip
          contentStyle={tooltipContentStyle}
          labelStyle={tooltipLabelStyle}
          formatter={(value) => [value, 'Responses']}
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
        />
        <Bar dataKey="count" fill={CHART_ACCENT} maxBarSize={22} radius={[0, 4, 4, 0]}>
          <LabelList dataKey="count" position="right" fill="#fff" fontSize={12} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SurveySourceChart;
